import React, { FC } from 'react';

/**
 * Data priming component for 'TimeClock'
 * - TODO: confirm and document Application browser refresh logic
 *    - when will the browser be refresh
 *    - if browser refresh is limited, initial data load will be handled via react-query
 */
const BootDataPrimerTimeClock: FC = () => {
  console.warn('BootDataPrimerTimeClock', 'TODO: append other react query hooks as we convert them over');
  return null;
};

export { BootDataPrimerTimeClock };
